import { Flex, Heading, Button } from "@adobe/react-spectrum";
import { sendTestWebNotification } from "../../utils/utils";

const NotificationSettings = () => {
  return (
    <Flex direction={"column"} marginX={"1.875%"}>
      <Heading level={2}>Notification Settings</Heading>
      <p>Test browser notifications to ensure you receive system-level alerts when contacts ring, even when this tab is not active.</p>
      <p><strong>If notifications aren't working, check these common issues:</strong></p>
      <ul>
        <li><strong>Mac/Windows:</strong> Focus/Do Not Disturb mode may be blocking notifications</li>
        <li><strong>Teams calls</strong> can suppress browser notifications</li>
        <li><strong>System-level notification settings</strong> may override browser settings</li>
      </ul>
      <p><strong>Troubleshooting steps:</strong></p>
      <ul>
        <li><strong>Chrome/Edge:</strong> Site settings → Notifications → Allow (if not already enabled)</li>
        <li><strong>Mac/Windows:</strong> Disable Focus/Do Not Disturb during work hours</li>
        <li><strong>Teams:</strong> Check Focus settings to prevent notification blocking</li>
        <li>Use the <strong>test button below</strong> to verify notifications are working</li>
      </ul>
      <Button
        UNSAFE_style={{
          width: "300px",
          height: "32px",
          font: "normal normal bold 14px/17px Adobe Clean",
          marginTop: "20px",
        }}
        variant="accent"
        onPress={sendTestWebNotification}
      >
        Test System Notifications
      </Button>
    </Flex>
  );
};

export default NotificationSettings;
